// React
import React from 'react';
// External
import { Button, Spinner } from 'react-bootstrap';
// Internal
import ButtonIconText from 'components/shared/atoms/ButtonIconText/ButtonIconText';
// Styles
import './styles.scss';

/**
 * @param {string} props.prevBtnText - The text to be display in the previous button
 * @param {string} props.nextBtnText - The text to be display in the next button
 * @param {string} props.cancelBtnText - The text to be display in the cancel button
 * @param {Function} props.prevBtnOnCLick - Previous button on click handler function
 * @param {Function} props.nextBtnOnCLick - Next button on click handler function
 * @param {Function} props.cancelBtnOnCLick - Cancel button on click handler function
 * @param {string} props.className - Class to be applied to the footer button actions
 * @param {Object} props.style - Style to be applied to the footer button actions
 */
class FooterBtnActions extends React.Component {
    constructor(props) {
        super(props);
        this.prevBtnText = props.prevBtnText ? props.prevBtnText : 'Previous';
        this.nextBtnText = props.nextBtnText ? props.nextBtnText : 'Next';
        this.cancelBtnText = props.cancelBtnText ? props.cancelBtnText : 'Exit';
        this.style = props.style;
        this.className = props.className ? props.className : '';
    }

    render() {
        return (
            <div className={`footer-btn-container ${this.className}`} style={this.props.style}>
                <div className="btn-container">
                    {
                        this.props.cancelBtnOnCLick
                            ? (
                                <Button
                                    className="btn-outline"
                                    variant="light"
                                    onClick={this.props.cancelBtnOnCLick}
                                    style={{ float: 'left' }}
                                    disabled={this.props.showSpinner ?? false}
                                >
                                    {this.props.cancelBtnText ? this.props.cancelBtnText : 'Exit'}
                                </Button>
                            ) : null
                    }
                    {
                        this.props.prevBtnOnCLick && !this.props.isEdit || this.props.isEdit && this.props.currentPage !== '#owner-pet-details'
                            ? (
                                <ButtonIconText
                                    className="btn-prev"
                                    text={this.props.prevBtnText ? this.props.prevBtnText : 'Previous'}
                                    iconPos={this.props.prevBtnIconActive ? this.props.prevBtnIconActive : 'left'}
                                    color="outline"
                                    onClick={this.props.prevBtnOnCLick}
                                    isDisabled={this.props.showSpinner ?? false}
                                />
                            ) : null
                    }
                    {
                        this.props.nextBtnOnCLick
                            ? (
                                <>
                                    <ButtonIconText
                                        className="btn-next"
                                        text={this.props.nextBtnText ? this.props.nextBtnText : 'Next'}
                                        iconPos={this.props.nextBtnIconActive ? this.props.nextBtnIconActive : 'right'}
                                        color="fill"
                                        onClick={this.props.nextBtnOnCLick}
                                        isDisabled={this.props.showSpinner ?? false}
                                    />
                                    {this.props.showSpinner ? <Spinner animation="border" /> : null}
                                </>
                            ) : null
                    }
                </div>
            </div>
        );
    }
}

export default FooterBtnActions;
